import React, { useState } from 'react';
import Modal from 'react-modal';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { Section } from '../../components/common';
import styled from 'styled-components';
import { HeroHeader, Footer } from '../../components/layout';
import ModalContent from './ModalContent';
import customStyles from './modalSettings';
import StartupList from './StartupList';
import { getFilteredItemsByHashTags, getTextByFilter } from '../../utils';

const Startups = ({ history, location, ...ohter }) => {
  const query = queryString.parse(location.search);

  const [startupIndex, setStartupIndex] = useState(0);
  const [isModalOpen, setModal] = useState(false);
  const [filter, setFilter] = useState(null);

  const filteredList = getFilteredItemsByHashTags(filter);

  const closeModal = () => {
    history.push(`/`);
    setModal(false);
  };

  const showNext = () => {
    setStartupIndex(startupIndex + 1);
    history.push(`/?projectId=${filteredList[startupIndex + 1]}`);
  };

  const showPrevious = () => {
    setStartupIndex(startupIndex - 1);
    history.push(`/?projectId=${filteredList[startupIndex - 1]}`);
  };

  const modalProps = {
    isOpen: isModalOpen,
    onRequestClose: closeModal,
    style: customStyles,
    contentLabel: 'Modal',
  };

  return (
    <BackgroundColor>
      <HeroHeader filter={filter} setFilter={setFilter} />
      <Section>
        <ChosenProjects>{getTextByFilter(filter, filteredList)}</ChosenProjects>
        <StartupList filter={filter} setModal={setModal} setStartupIndex={setStartupIndex} />
      </Section>
      <Modal {...modalProps}>
        {isModalOpen && <Close onClick={closeModal} />}
        {startupIndex > 0 && <ArrowLeft onClick={showPrevious} />}
        <ModalContent
          startupIndex={startupIndex}
          setStartupIndex={setStartupIndex}
          query={query}
          filteredList={filteredList}
        />
        {startupIndex < filteredList.length - 1 && <ArrowRight onClick={showNext} />}
      </Modal>
      <Footer />
    </BackgroundColor>
  );
};

export default withRouter(Startups);

const ChosenProjects = styled.div`
  font-size: 24px;
  margin: 32px 0 24px;
  color: ${props => props.theme.secondaryTextColor};
`;

const BackgroundColor = styled.div`
  background: #f2f4f8;
`;

const Arrow = styled.div`
  color: white;
  font-weight: bold;
  top: 50%;
  position: fixed;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
`;

const Close = styled(Arrow)`
  top: 32px;
  right: 32px;
  background: rgba(41, 44, 48, 0.6) url('https://welovedaily.com/img/icons/icon-cross-white.svg')
    center center no-repeat;
`;

const ArrowRight = styled(Arrow)`
  right: 5%;
  @media screen and (max-width: 786px) {
    display: none;
  }
  background: rgba(41, 44, 48, 0.6)
    url('https://welovedaily.com/img/icons/icon-halfarrow-white.svg') center center no-repeat;
`;

const ArrowLeft = styled(Arrow)`
  left: 5%;
  @media screen and (max-width: 786px) {
    display: none;
  }
  background: rgba(41, 44, 48, 0.6)
    url('https://welovedaily.com/img/icons/icon-halfarrow-back-white.svg') center center no-repeat;
`;
